import dateize from './dateize';
import digitize from './digitize';
import floatize from './floatize';
import momentize from './momentize';
import monetize from './monetize';
import namelize from './namelize';
import numberize from './numberize';
import patternize from './patternize';
import vehicleize from './vehicleize';

export default {
  dateize,
  digitize,
  floatize,
  momentize,
  monetize,
  namelize,
  numberize,
  patternize,
  vehicleize,
};
